export class SearchResults<T> {
  constructor(
    public results: T,
    public totalResults: number,
    public page: number,
    public count: number
  ) {}

  toString() {
    return (
      this.page.toString() +
      ': ' +
      this.count.toString() +
      ' (' +
      this.totalResults.toString() +
      ')'
    );
  }
}
